// Shared helpers for the Ledger Report — extracted from
// finishEntry/reports/LedgerReport.js so the Auto Report Mail print page
// parses/orders the SP's nested JSON exactly the same way as the manual
// report, instead of rendering the raw JSON text.

export const parseData = (data) => {
  try {
    if (data) {
      return JSON.parse(data);
    }
    return [];
  } catch (e) {
    return [];
  }
};

// Opening Balance should always render first, regardless of the order the
// API returns. Reordering alone would desync the running "balance" column
// from the SP, so it's recalculated here using the same DR/CR convention
// the backend uses.
export const reorderAccountData = (accountData) => {
  if (!Array.isArray(accountData) || !accountData.length) return accountData;

  const isOpeningRow = (item) =>
    item?.isOpening === 1 || item?.accountName === "*Opening Balance";

  const ordered = [
    ...accountData.filter(isOpeningRow),
    ...accountData.filter((item) => !isOpeningRow(item)),
  ];

  let runningBalance = 0;
  return ordered.map((item) => {
    const amount = Number(item?.amount) || 0;
    if (item?.type === "DR") {
      runningBalance += amount;
    } else if (item?.type === "CR") {
      runningBalance -= amount;
    }
    return { ...item, balance: runningBalance };
  });
};
